import { render, staticRenderFns } from "./ZipField.vue?vue&type=template&id=64ee7c1a&"
import script from "./ZipField.vue?vue&type=script&lang=js&"
export * from "./ZipField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports